/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import CreateHaes from '../components/CreateHaes/CreateHaes';
import HaesCard from '../components/HaesCard/HaesCard';
import Header from '../components/Header/Header';
import ProfileCard from '../components/ProfileCard/ProfileCard';
import RecentChats from '../components/RecentChats/RecentChats';
import UserSuggestion from '../components/UserSuggestion/UserSuggestion';

const Home = () => {
  return (
    <>
      <Header />
      <div className="app">
        <div className="app__left">
          <ProfileCard />
          <RecentChats />
        </div>
        <div>
          <CreateHaes />
          <HaesCard />
          <HaesCard />
          <HaesCard />
          <HaesCard />
          <HaesCard />
        </div>
        <div className="app__right">
          <UserSuggestion />
          <UserSuggestion />
        </div>
      </div>
    </>
  );
};

export default Home;
